// @ts-expect-error FIXME: REPAIR UPGRADE TO NEWER VERSION
import { motion, Variants } from 'framer-motion';

import {
    burgerPathBottomVariants,
    burgerPathMiddleVariants,
    burgerPathTopVariants,
} from './variants';

import { StyledButton } from './BurgerMenu.styled';

interface BurgerMenuProps {
    onClick: () => void;
}

const Path = (props: Variants) => (
    <motion.path
        stroke={'#13161B'}
        strokeLinecap="round"
        strokeWidth="2"
        transition={{ duration: 0.1 }}
        {...props}
    />
);

export const BurgerMenu = ({ onClick }: BurgerMenuProps) => {
    return (
        <StyledButton data-testid="Q8yU02r" onClick={onClick}>
            <svg fill="none" height="24" viewBox="0 0 24 24" width="24">
                <Path variants={burgerPathTopVariants} />
                <Path variants={burgerPathMiddleVariants} />
                <Path variants={burgerPathBottomVariants} />
            </svg>
        </StyledButton>
    );
};
